import {
  Users,
  Book,
  Building,
  ChevronRight,
  ChevronDown,
  FileText,
  Wallet,
} from "lucide-react";

export const cmsNavigation = [
  {
    id: "organization",
    title: "Organization",
    icon: Building,
    path: "/organisation",
    subServices: [
      {
        id: "sites",
        title: "Sites",
        dropDown: true,
        type: "SITE",
        path: "/organisation/sites",
        subSubServices: [
          { id: "hehe1", title: "Hehe 1", path: "/organisation/sites/hehe1" },
          { id: "hehe2", title: "Hehe 2", path: "/organisation/sites/hehe2" },
        ],
      },
      {
        id: "regions",
        title: "Regions",
        type: "REGION",
        path: "/organisation/regions",
        dropDown: true,
        subSubServices: [
          { id: "hehe1", title: "Hehe 1", path: "/organisation/regions/hehe1" },
          { id: "hehe2", title: "Hehe 2", path: "/organisation/regions/hehe2" },
        ],
      },
    ],
  },
  {
    title: "Fee Management",
    icon: Wallet,
  },
  {
    title: "User Management",
    icon: Users,
  },
  {
    id: "users",
    title: "Users",
    identity: "USERS",
    icon: Users,
    path: "/organisation/users",
    subServices: [
      {
        id: "manage-users",
        title: "Users",
        path: "/organisation/users/users-list",
        subSubServices: [
          { id: "hehe1", title: "Users 1", path: "/dashboard/partners" },
          { id: "hehe2", title: "Users2", path: "/dashboard/roles" },
        ],
      },
      {
        id: "groups",
        title: "Groups",
        path: "/organisation/users/groups",
        subSubServices: [
          { id: "hehe11", title: "Hehe 1", path: "/users/groups/hehe1" },
          { id: "hehe2", title: "Hehe 2", path: "/users/groups/hehe2" },
        ],
      },
      {
        id: "departments",
        title: "Departments",
        path: "/organisation/users/departments",
      },
      {
        id: "roles",
        title: "Roles",
        path: "/organisation/users/roles",
      },
    ],
  },
  {
    id: "academic",
    title: "Academic",
    icon: Book,
    path: "/academic",
    subServices: [
      // {
      //   id: "Course",
      //   title: "Course",
      //   path: "/organisation/academic/course",

      //   dropdown: false,
      // },
      // {
      //   id: "Divisions",
      //   title: "Divisions",
      //   path: "/organisation/academic/divisions",
      //   dropdown: false,
      // },

      {
        id: "Classes",
        title: "Classes",
        path: "/organisation/academic/classes",
        dropdown: false,
      },
      {
        id: "Tutor",
        title: "Tutor",
        path: "/organisation/academic/tutor",
        dropdown: false,
      },
      {
        id: "Subject",
        title: "Subject",
        path: "/organisation/academic/subject",
        dropdown: false,
      },
      {
        id: "Division Sections",
        title: "Sections",
        path: "/organisation/academic/division-sections",
        dropdown: false,
      },
      {
        id: "Tutor Assignment",
        title: "Assignment",
        path: "/organisation/academic/tutor-assignment",
        dropdown: false,
      },
      {
        id: "Tutor Homework",
        title: "Homework",
        path: "/organisation/academic/tutor-homework",
        dropdown: false,
      },
      {
        id: "Student",
        title: "Student",
        path: "/organisation/academic/student",
        dropdown: false,
      },
      {
        id: "Academic Year",
        title: "Academic Year",
        path: "/organisation/academic/academic-years",
      },
    ],
  },
  {
    id: "examination",
    title: "Examination",
    icon: Book,
    path: "organization/examination",
    subServices: [
      { id: "Templates", title: "Template", path: "examination/templates" },
      { id: "Series", title: "Series", path: "examination/series" },
    ],
  },
  {
    id: "fees",
    title: "Fees",
    icon: Book,
    path: "/fees",
    subServices: [
      { id: "fee-types", title: "Fee Types", path: "/fees/types" },
      { id: "collections", title: "Collections", path: "/fees/collections" },
    ],
  },
  {
    id: "library",
    title: "Library",
    icon: Book,
    path: "/organisation/library",
    subServices: [
      {
        id: "libraryList",
        title: "Library",
        path: "/organisation/library/library-list",
      },
      {
        id: "categories",
        title: "Categories",
        path: "/organisation/library/:id/library-details/categories",
      },
      {
        id: "library-penalty",
        title: "Library Penalty",
        path: "/organisation/library/:id/library-details/penalty",
      },
      {
        id: "publications",
        title: "Publications",
        path: "/organisation/library/:id/library-details/publications",
      },
      {
        id: "authors",
        title: "Authors",
        path: "/organisation/library/:id/library-details/authors",
      },
      {
        id: "books",
        title: "Books",
        path: "/organisation/library/:id/library-details/books",
      },
    ],
  },

  {
    id: "canteen",
    title: "Canteen",
    icon: Building,
    path: "/organisation/canteen",
    subServices: [
      {
        id: "canteenList",
        title: "Canteen",
        path: "/organisation/canteen/canteen-list",
      },
    ],
  },
  {
    id: "hostel",
    title: "Hostel",
    icon: Building,
    path: "/organisation/hostel",
    subServices: [
      {
        id: "hostelList",
        title: "Hostel",
        path: "/organisation/hostel/hostel-list",
      },
      {
        id: "rooms",
        title: "Rooms",
        path: "/organisation/hostel/:id/hostel-details/rooms",
      },

      {
        id: "complains",
        title: "Complains",
        path: "/organisation/hostel/:id/hostel-details/complains",
      },

      {
        id: "guests",
        title: "Guests",
        path: "/organisation/hostel/:id/hostel-details/guests",
      },

      // {
      //   id: "guests",
      //   title: "Guests",
      //   path: "/organisation/hostel/:id/hostel-details/guest",
      // },
      {
        id: "room-types",
        title: "Room Types",
        path: "/organisation/hostel/:id/hostel-details/room-types",
      },
      // {
      //   id: "room-facilities",
      //   title: "Room Facilities",
      //   path: "/organisation/hostel/facilities",
      // },
      {
        id: "food-menu",
        title: "Food Menu",
        path: "/organisation/hostel/:id/hostel-details/food-menu",
      },
      {
        id: "aplication",
        title: "Application",
        path: "/organisation/hostel/:id/hostel-details/application-detail",
      },
    ],
  },

  {
    id: "parking",
    title: "Parking",
    icon: Building,
    path: "/parking",
    subServices: [
      { id: "parking-lots", title: "Parking Lots", path: "/parking/lots" },
      { id: "parking-slips", title: "Parking Slips", path: "/parking/slips" },
    ],
  },

  {
    id: "transport",
    title: "Transport",
    icon: Building,
    path: "/organisation/transport",
    subServices: [
      {
        id: "vehicles",
        title: "Vehicles",
        path: "/organisation/transport/vehicles",
      },
      {
        id: "routes",
        title: "Routes",
        path: "/organisation/transport/:id/transport-details/routes",
      },
      {
        id: "stops",
        title: "Stops",
        path: "/organisation/transport/:id/transport-details/stops",
      },
      {
        id: "drivers",
        title: "Drivers",
        path: "/organisation/transport/:id/transport-details/drivers",
      },
      {
        id: "maintenance",
        title: "Maintenance",
        path: "/organisation/transport/:id/transport-details/maintenance",
      },
      {
        id: "booking",
        title: "Booking",
        path: "/organisation/transport/:id/transport-details/booking",
      },
      {
        id: "vehicle-schedule",
        title: "Vehicle Schedule",
        path: "/organisation/transport/:id/transport-details/vehicle-schedule",
      },
      {
        id: "payments",
        title: "Payments",
        path: "/organisation/transport/:id/transport-details/payments",
      },
      {
        id: "tickets",
        title: "Tickets",
        path: "/organisation/transport/:id/transport-details/tickets",
      },
      {
        id: "rating",
        title: "Rating",
        path: "/organisation/transport/:id/transport-details/rating",
      },
    ],
  },
  {
    id: "forms",
    title: "Forms",
    icon: FileText,
    path: "/forms",
    subServices: [{ id: "Forms", title: "Forms", path: "forms" }],
  },

  // Add other services similarly...
];
